import { useState, useEffect, useContext } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Typography, Table, TableBody, TableRow, TableCell, TableHead
} from '@mui/material';
import moment from 'moment';
import axios from 'axios';
import { MdChevronRight as NextIcon } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { ClickableTableRow, SimecUser } from 'components';
import Moment from 'react-moment';
import { AbsenceTypology } from 'helpers/Enums';
import { appUserContext } from 'helpers/services';


interface IProps {
    absenceId: string
    onClose: () => void
}

interface IAbsenceDetail {
    absenceId: string
    username: string
    startDate: moment.Moment
    endDate: moment.Moment
    typology: AbsenceTypology
    otherTypology: string
    notes: string
}

let AbsenceSchedule = (props: IProps) => {
    let history = useHistory();

    let { currentUser } = useContext(appUserContext);

    let [isLoading, setLoading] = useState(true);
    let [absence, setAbsence] = useState<IAbsenceDetail>();


    useEffect(() => {
        let getAbsenceDetails = async () => {
            try {
                setLoading(true);
                let res = await axios.get('/api/Schedule/GetScheduleAbsenceDetails', { params: { absenceId: props.absenceId } });
                setAbsence(res.data.item);
            } catch (error) { }
            finally {
                setLoading(false);
            }
        }

        getAbsenceDetails();
    }, []);

    let openDetails = () => {
        if (currentUser.simecClaims.canEditScheduling === true) {
            props.onClose();
            history.push(`/absence/edit/${props.absenceId}`);
        }
    }


    return (
        <Dialog
            open={true}
            maxWidth="md"
            fullWidth={true}
            scroll="paper"
        >
            {absence &&
                <>
                    <DialogTitle>
                        Dettagli assenza <SimecUser username={absence.username} />
                    </DialogTitle>
                    <DialogContent dividers>
                        {isLoading === false &&
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Tipologia</TableCell>
                                        <TableCell>Da data</TableCell>
                                        <TableCell>A data</TableCell>
                                        <TableCell>Note</TableCell>
                                        {currentUser.simecClaims.canEditScheduling === true && <TableCell />}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <ClickableTableRow onClick={openDetails}>
                                        <TableCell>
                                            {absence.typology === AbsenceTypology.NotAvailable
                                                ? "Non disponibile"
                                                : absence.otherTypology
                                            }
                                        </TableCell>
                                        <TableCell>
                                            <Moment date={absence.startDate} format="DD/MM/YYYY" />
                                        </TableCell>
                                        <TableCell>
                                            <Moment date={absence.endDate} format="DD/MM/YYYY" />
                                        </TableCell>
                                        <TableCell>{absence.notes}</TableCell>
                                        {currentUser.simecClaims.canEditScheduling === true &&
                                            <TableCell align="right">
                                                <NextIcon />
                                            </TableCell>
                                        }
                                    </ClickableTableRow>
                                </TableBody>
                            </Table>
                        }
                    </DialogContent>
                </>
            }
            <DialogActions>
                <Button onClick={props.onClose} color="secondary">
                    Chiudi
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AbsenceSchedule;